module.exports = __webpack_public_path__ + "img/toni.1248294e.png";